export default [
  {
    name: 'Ale',
    code: '1440',
  },
  {
    name: 'Alingsås',
    code: '1489',
  },
  {
    name: 'Alvesta',
    code: '0764',
  },
  { name: 'Aneby', code: '0604' },
  { name: 'Arboga', code: '1984' },
  { name: 'Arjeplog', code: '2506' },
  { name: 'Arvidsjaur', code: '2505' },
  { name: 'Arvika', code: '1784' },
  { name: 'Askersund', code: '1882' },
  { name: 'Avesta', code: '2084' },
  { name: 'Bengtsfors', code: '1460' },
  { name: 'Berg', code: '2326' },
  { name: 'Bjurholm', code: '2403' },
  { name: 'Bjuv', code: '1260' },
  { name: 'Boden', code: '2582' },
  { name: 'Bollebygd', code: '1443' },
  { name: 'Bollnäs', code: '2183' },
  { name: 'Borgholm', code: '0885' },
  { name: 'Borlänge', code: '2081' },
  { name: 'Borås', code: '1490' },
  { name: 'Botkyrka', code: '0127' },
  { name: 'Boxholm', code: '0560' },
  { name: 'Bromölla', code: '1272' },
  { name: 'Bräcke', code: '2305' },
  { name: 'Burlöv', code: '1231' },
  { name: 'Båstad', code: '1278' },
  { name: 'Dals-Ed', code: '1438' },
  { name: 'Danderyd', code: '0162' },
  { name: 'Degerfors', code: '1862' },
  { name: 'Dorotea', code: '2425' },
  { name: 'Eda', code: '1730' },
  { name: 'Ekerö', code: '0125' },
  { name: 'Eksjö', code: '0686' },
  { name: 'Emmaboda', code: '0862' },
  { name: 'Enköping', code: '0381' },
  { name: 'Eskilstuna', code: '0484' },
  { name: 'Eslöv', code: '1285' },
  { name: 'Essunga', code: '1445' },
  { name: 'Fagersta', code: '1982' },
  { name: 'Falkenberg', code: '1382' },
  { name: 'Falköping', code: '1499' },
  { name: 'Falun', code: '2080' },
  { name: 'Filipstad', code: '1782' },
  { name: 'Finspång', code: '0562' },
  { name: 'Flen', code: '0482' },
  { name: 'Forshaga', code: '1763' },
  { name: 'Färgelanda', code: '1439' },
  { name: 'Gagnef', code: '2026' },
  { name: 'Gislaved', code: '0662' },
  { name: 'Gnesta', code: '0461' },
  { name: 'Gnosjö', code: '0617' },
  { name: 'Gotland', code: '0980' },
  { name: 'Grums', code: '1764' },
  { name: 'Grästorp', code: '1444' },
  { name: 'Gullspång', code: '1447' },
  { name: 'Gällivare', code: '2523' },
  { name: 'Gävle', code: '2180' },
  { name: 'Göteborg', code: '1480' },
  { name: 'Götene', code: '1471' },
  { name: 'Habo', code: '0643' },
  { name: 'Hagfors', code: '1783' },
  { name: 'Hallsberg', code: '1861' },
  { name: 'Hallstahammar', code: '1961' },
  { name: 'Halmstad', code: '1380' },
  { name: 'Hammarö', code: '1761' },
  { name: 'Haninge', code: '0136' },
  { name: 'Haparanda', code: '2583' },
  { name: 'Heby', code: '0331' },
  { name: 'Hedemora', code: '2083' },
  { name: 'Helsingborg', code: '1283' },
  { name: 'Herrljunga', code: '1466' },
  { name: 'Hjo', code: '1497' },
  { name: 'Hofors', code: '2104' },
  { name: 'Huddinge', code: '0126' },
  { name: 'Hudiksvall', code: '2184' },
  { name: 'Hultsfred', code: '0860' },
  { name: 'Hylte', code: '1315' },
  { name: 'Håbo', code: '0305' },
  { name: 'Hällefors', code: '1863' },
  { name: 'Härjedalen', code: '2361' },
  { name: 'Härnösand', code: '2280' },
  { name: 'Härryda', code: '1401' },
  { name: 'Hässleholm', code: '1293' },
  { name: 'Höganäs', code: '1284' },
  { name: 'Högsby', code: '0821' },
  { name: 'Hörby', code: '1266' },
  { name: 'Höör', code: '1267' },
  { name: 'Jokkmokk', code: '2510' },
  { name: 'Järfälla', code: '0123' },
  { name: 'Jönköping', code: '0680' },
  { name: 'Kalix', code: '2514' },
  { name: 'Kalmar', code: '0880' },
  { name: 'Karlsborg', code: '1446' },
  { name: 'Karlshamn', code: '1082' },
  { name: 'Karlskoga', code: '1883' },
  { name: 'Karlskrona', code: '1080' },
  { name: 'Karlstad', code: '1780' },
  { name: 'Katrineholm', code: '0483' },
  { name: 'Kil', code: '1715' },
  { name: 'Kinda', code: '0513' },
  { name: 'Kiruna', code: '2584' },
  { name: 'Klippan', code: '1276' },
  { name: 'Knivsta', code: '0330' },
  { name: 'Kramfors', code: '2282' },
  { name: 'Kristianstad', code: '1290' },
  { name: 'Kristinehamn', code: '1781' },
  { name: 'Krokom', code: '2309' },
  { name: 'Kumla', code: '1881' },
  { name: 'Kungsbacka', code: '1384' },
  { name: 'Kungsör', code: '1960' },
  { name: 'Kungälv', code: '1482' },
  { name: 'Kävlinge', code: '1261' },
  { name: 'Köping', code: '1983' },
  { name: 'Laholm', code: '1381' },
  { name: 'Landskrona', code: '1282' },
  { name: 'Laxå', code: '1860' },
  { name: 'Lekeberg', code: '1814' },
  { name: 'Leksand', code: '2029' },
  { name: 'Lerum', code: '1441' },
  { name: 'Lessebo', code: '0761' },
  { name: 'Lidingö', code: '0186' },
  { name: 'Lidköping', code: '1494' },
  { name: 'Lilla Edet', code: '1462' },
  { name: 'Lindesberg', code: '1885' },
  { name: 'Linköping', code: '0580' },
  { name: 'Ljungby', code: '0781' },
  { name: 'Ljusdal', code: '2161' },
  { name: 'Ljusnarsberg', code: '1864' },
  { name: 'Lomma', code: '1262' },
  { name: 'Ludvika', code: '2085' },
  { name: 'Luleå', code: '2580' },
  { name: 'Lund', code: '1281' },
  { name: 'Lycksele', code: '2481' },
  { name: 'Lysekil', code: '1484' },
  { name: 'Malmö', code: '1280' },
  { name: 'Malung', code: '2023' },
  { name: 'Malå', code: '2418' },
  { name: 'Mariestad', code: '1493' },
  { name: 'Mark', code: '1463' },
  { name: 'Markaryd', code: '0767' },
  { name: 'Mellerud', code: '1461' },
  { name: 'Mjölby', code: '0586' },
  { name: 'Mora', code: '2062' },
  { name: 'Motala', code: '0583' },
  { name: 'Mullsjö', code: '0642' },
  { name: 'Munkedal', code: '1430' },
  { name: 'Munkfors', code: '1762' },
  { name: 'Mölndal', code: '1481' },
  { name: 'Mönsterås', code: '0861' },
  { name: 'Mörbylånga', code: '0840' },
  { name: 'Nacka', code: '0182' },
  { name: 'Nora', code: '1884' },
  { name: 'Norberg', code: '1962' },
  { name: 'Nordanstig', code: '2132' },
  { name: 'Nordmaling', code: '2401' },
  { name: 'Norrköping', code: '0581' },
  { name: 'Norrtälje', code: '0188' },
  { name: 'Norsjö', code: '2417' },
  { name: 'Nybro', code: '0881' },
  { name: 'Nykvarn', code: '0140' },
  { name: 'Nyköping', code: '0480' },
  { name: 'Nynäshamn', code: '0192' },
  { name: 'Nässjö', code: '0682' },
  { name: 'Ockelbo', code: '2101' },
  { name: 'Olofström', code: '1060' },
  { name: 'Orsa', code: '2034' },
  { name: 'Orust', code: '1421' },
  { name: 'Osby', code: '1273' },
  { name: 'Oskarshamn', code: '0882' },
  { name: 'Ovanåker', code: '2121' },
  { name: 'Oxelösund', code: '0481' },
  { name: 'Pajala', code: '2521' },
  { name: 'Partille', code: '1402' },
  { name: 'Perstorp', code: '1275' },
  { name: 'Piteå', code: '2581' },
  { name: 'Ragunda', code: '2303' },
  { name: 'Robertsfors', code: '2409' },
  { name: 'Ronneby', code: '1081' },
  { name: 'Rättvik', code: '2031' },
  { name: 'Sala', code: '1981' },
  { name: 'Salem', code: '0128' },
  { name: 'Sandviken', code: '2181' },
  { name: 'Sigtuna', code: '0191' },
  { name: 'Simrishamn', code: '1291' },
  { name: 'Sjöbo', code: '1265' },
  { name: 'Skara', code: '1495' },
  { name: 'Skellefteå', code: '2482' },
  { name: 'Skinnskatteberg', code: '1904' },
  { name: 'Skurup', code: '1264' },
  { name: 'Skövde', code: '1496' },
  { name: 'Smedjebacken', code: '2061' },
  { name: 'Sollefteå', code: '2283' },
  { name: 'Sollentuna', code: '0163' },
  { name: 'Solna', code: '0184' },
  { name: 'Sorsele', code: '2422' },
  { name: 'Sotenäs', code: '1427' },
  { name: 'Staffanstorp', code: '1230' },
  { name: 'Stenungsund', code: '1415' },
  { name: 'Stockholm', code: '0180' },
  { name: 'Storfors', code: '1760' },
  { name: 'Storuman', code: '2421' },
  { name: 'Strängnäs', code: '0486' },
  { name: 'Strömstad', code: '1486' },
  { name: 'Strömsund', code: '2313' },
  { name: 'Sundbyberg', code: '0183' },
  { name: 'Sundsvall', code: '2281' },
  { name: 'Sunne', code: '1766' },
  { name: 'Surahammar', code: '1907' },
  { name: 'Svalöv', code: '1214' },
  { name: 'Svedala', code: '1263' },
  { name: 'Svenljunga', code: '1465' },
  { name: 'Säffle', code: '1785' },
  { name: 'Säter', code: '2082' },
  { name: 'Sävsjö', code: '0684' },
  { name: 'Söderhamn', code: '2182' },
  { name: 'Söderköping', code: '0582' },
  { name: 'Södertälje', code: '0181' },
  { name: 'Sölvesborg', code: '1083' },
  { name: 'Tanum', code: '1435' },
  { name: 'Tibro', code: '1472' },
  { name: 'Tidaholm', code: '1498' },
  { name: 'Tierp', code: '0360' },
  { name: 'Timrå', code: '2262' },
  { name: 'Tingsryd', code: '0763' },
  { name: 'Tjörn', code: '1419' },
  { name: 'Tomelilla', code: '1270' },
  { name: 'Torsby', code: '1737' },
  { name: 'Torsås', code: '0834' },
  { name: 'Tranemo', code: '1452' },
  { name: 'Tranås', code: '0687' },
  { name: 'Trelleborg', code: '1287' },
  { name: 'Trollhättan', code: '1488' },
  { name: 'Trosa', code: '0488' },
  { name: 'Tyresö', code: '0138' },
  { name: 'Täby', code: '0160' },
  { name: 'Töreboda', code: '1473' },
  { name: 'Uddevalla', code: '1485' },
  { name: 'Ulricehamn', code: '1491' },
  { name: 'Umeå', code: '2480' },
  { name: 'Upplands Väsby', code: '0114' },
  { name: 'Upplands-Bro', code: '0139' },
  { name: 'Uppsala', code: '0380' },
  { name: 'Uppvidinge', code: '0760' },
  { name: 'Vadstena', code: '0584' },
  { name: 'Vaggeryd', code: '0665' },
  { name: 'Valdemarsvik', code: '0563' },
  { name: 'Vallentuna', code: '0115' },
  { name: 'Vansbro', code: '2021' },
  { name: 'Vara', code: '1470' },
  { name: 'Varberg', code: '1383' },
  { name: 'Vaxholm', code: '0187' },
  { name: 'Vellinge', code: '1233' },
  { name: 'Vetlanda', code: '0685' },
  { name: 'Vilhelmina', code: '2462' },
  { name: 'Vimmerby', code: '0884' },
  { name: 'Vindeln', code: '2404' },
  { name: 'Vingåker', code: '0428' },
  { name: 'Vårgårda', code: '1442' },
  { name: 'Vänersborg', code: '1487' },
  { name: 'Vännäs', code: '2460' },
  { name: 'Värmdö', code: '0120' },
  { name: 'Värnamo', code: '0683' },
  { name: 'Västervik', code: '0883' },
  { name: 'Västerås', code: '1980' },
  { name: 'Växjö', code: '0780' },
  { name: 'Ydre', code: '0512' },
  { name: 'Ystad', code: '1286' },
  { name: 'Åmål', code: '1492' },
  { name: 'Ånge', code: '2260' },
  { name: 'Åre', code: '2321' },
  { name: 'Årjäng', code: '1765' },
  { name: 'Åsele', code: '2463' },
  { name: 'Åstorp', code: '1277' },
  { name: 'Åtvidaberg', code: '0561' },
  { name: 'Älmhult', code: '0765' },
  { name: 'Älvdalen', code: '2039' },
  { name: 'Älvkarleby', code: '0319' },
  { name: 'Älvsbyn', code: '2560' },
  { name: 'Ängelholm', code: '1292' },
  { name: 'Öckerö', code: '1407' },
  { name: 'Ödeshög', code: '0509' },
  { name: 'Örebro', code: '1880' },
  { name: 'Örkelljunga', code: '1257' },
  { name: 'Örnsköldsvik', code: '2284' },
  { name: 'Östersund', code: '2380' },
  { name: 'Österåker', code: '0117' },
  { name: 'Östhammar', code: '0382' },
  { name: 'Östra Göinge', code: '1256' },
  { name: 'Överkalix', code: '2513' },
  { name: 'Övertorneå', code: '2518' },
];
